import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  HostBinding,
  OnInit
} from '@angular/core';

export interface IIcBaseComponent {
  defaultWidth: number;
  defaultHeight: number;
}

const toPx = (value: number) => `${value}px`;

/**
 * This component is a replacement for app-icon (uses icon-spite + <use> to render SVG icon)
 */
@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IcBaseComponent implements OnChanges, OnInit {
  @Input() color?: string;

  @Input() top?: number;
  @Input() left?: number;
  @Input() right?: number;
  @Input() bottom?: number;

  @Input() size?: number;
  @Input() width?: number;
  @Input() height?: number;

  @HostBinding('class.ic') class = true;

  defaultWidth: number;
  defaultHeight: number;

  constructor(private elmRef: ElementRef<HTMLElement>) {}

  ngOnInit() {
    this.setStyle();
    this.setSize();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setStyle();
    this.setSize();
  }

  setSize() {
    // If there is width or height, use it (allows only one dimension to be set)
    if (!this.width && !this.height) {
      // If width and height are not set, use size
      if (this.size) {
        this.width = this.size;
        this.height = this.size;
      } else {
        // If size is not set, use default width and height
        this.width = this.defaultWidth;
        this.height = this.defaultHeight;
      }
    }

    if (this.width) {
      this.setSvgAttribute('width', toPx(this.width));
    }

    if (this.height) {
      this.setSvgAttribute('height', toPx(this.height));
    }
  }

  setStyle() {
    if (this.color) {
      this.elmRef.nativeElement.style.color = this.color;
    }

    if (this.top) {
      this.elmRef.nativeElement.style.top = toPx(this.top);
    }

    if (this.bottom) {
      this.elmRef.nativeElement.style.bottom = toPx(this.bottom);
    }

    if (this.left) {
      this.elmRef.nativeElement.style.left = toPx(this.left);
    }

    if (this.right) {
      this.elmRef.nativeElement.style.right = toPx(this.right);
    }
  }

  private setSvgAttribute(name: string, value: string) {
    (this.elmRef.nativeElement.children[0] as any).setAttribute(name, value);
  }
}
